import { configureStore, combineReducers } from '@reduxjs/toolkit'

import app from './app'
import siteLane from './siteLane'
import device from './device'
import deviceLogs from './deviceLogs'
import dashboard from './dashboard'
import account from './account'
import reports from './reports'
import { injectStore } from 'src/api/interceptors/errorInterceptor'

const reducers = {
  app,
  siteLane,
  device,
  deviceLogs,
  dashboard,
  account,
  reports,
}

const combinedReducer = combineReducers(reducers)

const rootReducer = (state, action) => {
  if (action.type === 'RESET_ALL_STATE') {
    return combinedReducer(undefined, action)
  }

  return combinedReducer(state, action)
}

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
})

injectStore(store)
export default store
